import { FAQ } from "../features/FAQ/faqCollection";

export default function FAQ_Page() {
    return (
        <div className="container my-4 rounded p-3 w-75 lh-lg"
            id="FAQ-accordion">
            <FAQ />
        </div>
    );
};

